import { AddAsset } from '@unistocks/features/watchlists/add-asset';
import { t } from '@unistocks/shared/localization/index.ts';
import { useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

export default function AddAssetScreen() {
  const { id, sectionId } = useLocalSearchParams<{ id: string; sectionId?: string }>();

  return (
    <>
      <Head>
        <title>{t('::AddWhat', { 0: t('::Holdings').toLowerCase() })}</title>
      </Head>
      <AddAsset id={id} sectionId={sectionId} />
    </>
  );
}
